module.exports = __webpack_public_path__ + "static/apple-banner-2a9d59fd32289293e7512dedcb3a95d3.jpg";